module.exports = __webpack_public_path__ + "assets/img/operaterule_step4.59e9ee20.png";